module.exports = __webpack_public_path__ + "static/media/stich_page11.43885032.gif";